//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import PageLayout from "../page/PageLayout";
import RouteView from "./RouteView";
export default {
  name: 'IframePageContent',
  data: function data() {
    return {
      url: '',
      id: '',
      iframeWin: {}
    };
  },
  props: {
    src: {
      type: String
    }
  },
  created: function created() {
    this.goUrl();
  },
  mounted: function mounted() {
    this.iframeWin = this.$refs.iframe.contentWindow;
  },
  updated: function updated() {
    this.goUrl();
  },
  watch: {
    $route: function $route(to, from) {
      this.goUrl();
    }
  },
  methods: {
    goUrl: function goUrl() {
      var url = this.$route.meta.url;
      var id = this.$route.path;
      this.id = id; //url = "http://www.baidu.com"

      console.log('------url------' + url);

      if (url !== null && url !== undefined) {
        this.url = url; //window.open(this.url);
      }
    }
  }
};